"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  bytesToSize: true
};
exports.bytesToSize = void 0;
var _dimension = require("./dimension");
Object.keys(_dimension).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dimension[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dimension[key];
    }
  });
});
var _fileType = require("./file-type");
Object.keys(_fileType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fileType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fileType[key];
    }
  });
});
var _mimeType = require("./mime-type");
Object.keys(_mimeType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _mimeType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mimeType[key];
    }
  });
});
var _uploadFile = require("./upload-file");
Object.keys(_uploadFile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _uploadFile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _uploadFile[key];
    }
  });
});
var _validateDimension = require("./validate-dimension");
Object.keys(_validateDimension).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _validateDimension[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateDimension[key];
    }
  });
});
var _validateFileSize = require("./validate-file-size");
Object.keys(_validateFileSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _validateFileSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateFileSize[key];
    }
  });
});
var _validateFileType = require("./validate-file-type");
Object.keys(_validateFileType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _validateFileType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateFileType[key];
    }
  });
});
const bytesToSize = (bytes, unit = 1024) => {
  if (bytes === 0) return "0 Byte";
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const index = Math.floor(Math.log(bytes) / Math.log(unit));
  const roundedValue = Math.round(bytes / Math.pow(unit, index));
  return `${roundedValue} ${sizes[index]}`;
};
exports.bytesToSize = bytesToSize;